import React from "react";
import PropTypes from "prop-types";
import Container from "@mui/material/Container";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Stack from "@mui/material/Stack";
import DialogContent from "@mui/material/DialogContent";
import { useTheme } from "@mui/material/styles";
import DialogHeader from "core/components/DialogHeader";
import { getFullScreenMenuDialogSurfaces } from "arena/utils/fullScreenMenuDialogSurfaces";
import GalleryMenuItemDialogItem from "./GalleryMenuItemDialogItem";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function GalleryMenuItemDialog({ open, onClose, menuItem }) {
  const theme = useTheme();
  const { paperProps, headerSx } = getFullScreenMenuDialogSurfaces(theme);

  return (
    <Dialog
      fullWidth
      TransitionComponent={Transition}
      fullScreen
      open={open}
      onClose={onClose}
      scroll="paper"
      PaperProps={paperProps}
    >
      {menuItem && (
        <>
          <DialogHeader
            title={menuItem.label}
            onClose={onClose}
            sx={headerSx}
          />
          <DialogContent sx={{ pl: 0, pr: 0, bgcolor: "background.body" }}>
            <Container disableGutters>
              <Stack spacing={4}>
                {menuItem.items.map((item) => (
                  <GalleryMenuItemDialogItem
                    item={item}
                    key={item.id}
                    onClick={onClose}
                  />
                ))}
              </Stack>
            </Container>
          </DialogContent>
        </>
      )}
    </Dialog>
  );
}

GalleryMenuItemDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  menuItem: PropTypes.shape({
    label: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        title: PropTypes.string,
      })
    ),
  }),
};
